export const splitArrayChunks = (arr, chunk_length) => {
  var nb_blocks = Math.floor(arr?.length / chunk_length)
  var new_arr = []
  for (var k = 0; k < nb_blocks; k++) {
    new_arr.push(arr?.slice(k * chunk_length, (k + 1) * chunk_length))
  }
  new_arr.push(arr?.slice(nb_blocks * chunk_length, arr?.length))
  return new_arr
}
